import { CHCpdlViewer } from './pdl-viewer-component.js';
export { CHCpdlViewer };

customElements.define('chcapp-pdl-viewer', CHCpdlViewer);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-pdl-viewer': CHCpdlViewer;
  }
}
